import React, { useEffect, useState, startTransition } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import useTitle from "../Title";
// import { toast } from "../toast";
import { get, set, remove, runTransaction } from "firebase/database";
import { useLocation } from "react-router-dom";

  const FILTERDEFAULTS = {
    search: "",
    type: "all",
    hidePrevious: true,      // Upcoming Only
    sortDirection: "asc",    // Closest
    price: ""
  };
  
function MusicContent() {

  useTitle("- Music");

  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUserId, setCurrentUserId] = useState(null);
  const navigate = useNavigate();

  const [owners, setOwners] = useState({});

  useEffect(() => {
    const auth = getAuth();
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUserId(user ? user.uid : null);
    });

    return () => unsubscribe();
  }, []);



  useEffect(() => {
    const getData = () => {
      const database = getDatabase();
      const eventsRef = ref(database, "EVENTS/EVENT/MUSIC");

        const createLabel = (
        imgSrc,
        customSrc,
        siteUrl,
        isTodays,
        type,
        price,
        isSoldOut,
        isVerified,
        isSponsored,
        isNew,
        isOneDayExpired,
        eventId
      ) => (
       <div className={`position-relative text-center rounded-lg card-image-effect ${isTodays ? "today-border" : ""}`}>
          {isOneDayExpired && (
            <div className="onedayexpired-border-badge">Expired Recently</div>
          )}
          
          {isTodays && (
            <div className="today-border-badge">Today</div>
          )}

          {isNew && (
            <div className="new-border-badge">Recently Added</div>
          )}

            {isVerified ===  "Y" ?(
              <div className={`isverify`}> 
                 <i className={`bi bi-check2-circle verified-badge2`}></i>
              </div>
            ) : (
              <>
              </>
            )}

            {isSponsored ===  "Y" ?(
                <div className={`issponsored`}> 
                   Sponsored
                </div>
            ) : (
              <>
              </>
            )}

          {isSoldOut === "Y" ? (
            <div className="soldout-border-badge">Sold Out</div>
          ) : (
           <div className="price-border-badge">
              {price === "0" ? "Free" : !isNaN(price) ? `£${price}` : "tbc"}
            </div>
          )}


         {customSrc ? (

              <img
                src={customSrc}
                alt="event"
                className="w-full object-cover sm:aspect-2/1 hover:cursor-pointer max-sm:h-80 mx-width card-image-effect-hover"
                style={{ viewTransitionName: `event-image-${eventId}`, display: "block" }}
                loading="eager"
              />

            ) : imgSrc ? (

              <img
                src={`/assets/img/${type.toLowerCase()}/${imgSrc}-640.png`}
                srcSet={`
                  /assets/img/${type.toLowerCase()}/${imgSrc}-480.png 480w,
                  /assets/img/${type.toLowerCase()}/${imgSrc}-640.png 640w,
                  /assets/img/${type.toLowerCase()}/${imgSrc}-1024.png 1024w,
                  /assets/img/${type.toLowerCase()}/${imgSrc}-1600.png 1600w,
                  /assets/img/${type.toLowerCase()}/${imgSrc}-2400.png 2400w
                `}
                alt={imgSrc}
                className="w-full object-cover sm:aspect-2/1 hover:cursor-pointer max-sm:h-80 mx-width card-image-effect-hover"
                style={{ viewTransitionName: `event-image-${eventId}`, display: "block" }}
                loading="eager"
              />

            ) : (

              <div
                className={`event-image-fallback-content  event-image-${type} sm:aspect-2/1 max-sm:h-80 mx-width`}
                style={{ viewTransitionName: `event-image-${eventId}` }}
              />

            )}


        </div>
      );

      const formatEventDate = (dateStr) => {
        const [day, month, year] = dateStr.split("/").map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      };
      const getOrdinalSuffix = (num) => {
        const j = num % 10;
        const k = num % 100;
        if (j === 1 && k !== 11) return "st ";
        if (j === 2 && k !== 12) return "nd ";
        if (j === 3 && k !== 13) return "rd ";
        return "th ";
      };
         const formatDay = (dateStr) => {
        const [day, month, year] = dateStr.split("/").map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          weekday: "long",
          // day: "numeric",
          // month: "long",
          // year: "numeric",
        });
      };

       const formatDate = (dateStr) => {
        const [day, month, year] = dateStr.split("/").map(Number);
        const date = new Date(year, month - 1, day);
        const dayNum = date.getDate();
        return dayNum + getOrdinalSuffix(dayNum);
      };

       const formatMonth = (dateStr) => {
        const [day, month, year] = dateStr.split("/").map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          // weekday: "short",
          // day: "numeric",
          month: "long",
          // year: "numeric",
        });
      };
       const formatYear = (dateStr) => {
        const [day, month, year] = dateStr.split("/").map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", {
          // weekday: "short",
          // day: "numeric",
          // month: "long",
          year: "numeric",
        });
      };

      // Start listening to Firebase
      onValue(eventsRef, (snapshot) => {
        const data = snapshot.val();

        if (data) {
          const formatted = Object.entries(data).map(([key, value]) => {
            const type = value.EVENT_TYPE || "DEFAULT";

            const imgNUM = value.EVENT_IMAGENUM || "";
            const customImage = value.EVENT_IMAGE || null;

            const imageMap = {
              OTHER: `other${imgNUM}`,
            };

            const presetImg = imgNUM ? imageMap[type] || imageMap.DEFAULT : null;

            let imgFile = null;
            let customSrc = null;

            if (customImage) {
              customSrc = `/assets/img/uploads/events/${customImage}.png`;
            } else if (presetImg) {
              imgFile = presetImg;
            }

            var price = value.EVENT_PRICE || "0";
            var isSoldOut = value.EVENT_SOLDOUT || "N";

            var isVerified = value.EVENT_VERIFIED || "N";
            var isSponsored = value.EVENT_SPONSORED || "N";

            let isTodays = false;

            if (value.EVENT_DATE) {
              const [day, month, year] = value.EVENT_DATE.split("/");
              const eventDate = new Date(year, month - 1, day);
              const today = new Date();

              // Calculate the end date (start date + extra days if they exist)
              let endDate = new Date(year, month - 1, day);
              if (value.EVENT_EXTRADAYS && Number(value.EVENT_EXTRADAYS) > 0) {
                endDate.setDate(endDate.getDate() + Number(value.EVENT_EXTRADAYS));
              }

              // Check if today falls within the event period (inclusive)
              eventDate.setHours(0, 0, 0, 0);
              endDate.setHours(0, 0, 0, 0);
              today.setHours(0, 0, 0, 0);

              isTodays = today.getTime() >= eventDate.getTime() && today.getTime() <= endDate.getTime();
            }

            var isNew = false;
            if (value.EVENT_CREATED) {

              const dateParts = value.EVENT_CREATED.split(" ")[0]; // Get just the date part "18/7/2026"
               const [day, month, year] = dateParts.split("/");
                const eventNewDate = new Date(year, month - 1, day);
              const today = new Date();

           
                eventNewDate.setHours(0, 0, 0, 0);
              today.setHours(0, 0, 0, 0);

              const differenceInDays = (today.getTime() - eventNewDate.getTime()) / (1000 * 60 * 60 * 24);

              isNew = differenceInDays >= 0 && differenceInDays <= 5;
            }
          

            // Calculate expiration status before creating label
            let isExpired = false;
            let isOneDayExpired = false;

            if (value.EVENT_DATE) {
              const [day, month, year] = value.EVENT_DATE.split("/");
              const eventDate = new Date(year, month - 1, day);
              const today = new Date();

              // Calculate the end date (start date + extra days if they exist)
              let endDate = eventDate;
              if (value.EVENT_EXTRADAYS && Number(value.EVENT_EXTRADAYS) > 0) {
                endDate = new Date(year, month - 1, day);
                endDate.setDate(endDate.getDate() + Number(value.EVENT_EXTRADAYS));
              }

              // Compare dates at midnight
              endDate.setHours(0, 0, 0, 0);
              today.setHours(0, 0, 0, 0);

              isExpired = endDate < today;

              // Check if event expired within the last 1 day (0-1 days old)
              if (isExpired) {
                const oneDayAgo = new Date(today);
                oneDayAgo.setDate(oneDayAgo.getDate() - 1);
                isOneDayExpired = endDate >= oneDayAgo && endDate < today;
              }
            }

            const label = createLabel(
              imgFile,
              customSrc,
              value.EVENT_SITE,
              isTodays,
              type,
              price,
              isSoldOut,
              isVerified,
              isSponsored,
              isNew,
              isOneDayExpired,
              key
            );

            const dateDisplay = value.EVENT_DATE
              ? formatEventDate(value.EVENT_DATE)
              : "Date not available";

              const dateDayDisplay = value.EVENT_DATE
              ? formatDay(value.EVENT_DATE)
              : "";

              const dateDateDisplay = value.EVENT_DATE
              ? formatDate(value.EVENT_DATE)
              : "";

              const dateMonthDisplay = value.EVENT_DATE
              ? formatMonth(value.EVENT_DATE)
              : "";

              const dateYearDisplay = value.EVENT_DATE
              ? formatYear(value.EVENT_DATE)
              : "";

            let extraDays = Number(value.EVENT_EXTRADAYS) || 0;
            let FullEndingDate = "";
            let dateEndDateDisplay = "";

            if (extraDays > 0) {
              const [day, month, year] = value.EVENT_DATE.split("/");
              const dateObj = new Date(year, month - 1, day);
              dateObj.setDate(dateObj.getDate() + Number(extraDays));

              const options = { 
                weekday: "long", 
                year: "numeric", 
                month: "long", 
                day: "numeric",
              };

              const formattedDate = `${dateObj.toLocaleDateString("en-GB", options)}`;
              FullEndingDate = formattedDate;
              
              const endDayNum = dateObj.getDate();
              dateEndDateDisplay = endDayNum + getOrdinalSuffix(endDayNum);
            }

            return {
              id: key,
              ...value,
              label,
              dateDisplay,
              dateDayDisplay,
              dateDateDisplay,
              dateEndDateDisplay,
              dateMonthDisplay,
              dateYearDisplay,
              FullEndingDate,
              isNew,
              isOneDayExpired,
              expiredEvent: isExpired ? "grayscale" : "",
              isExpiredtext: isExpired ? "line-through grayscale" : "",
            };
          });

          setItems(formatted);
          setLoading(false);
        } else {
          setItems([]);
          setLoading(false);
        }
      });
    };

    getData();
  }, []);
  
  // Fetch owner records for listed items (cached by UID)
  useEffect(() => {
    if (!items || items.length === 0) return;
    const db = getDatabase();
    const uniqueOwnerIds = Array.from(new Set(items.map((it) => it.EVENT_OWNER).filter(Boolean)));
    const toFetch = uniqueOwnerIds.filter((uid) => owners[uid] === undefined);
    if (toFetch.length === 0) return;

    Promise.all(
      toFetch.map((uid) =>
        get(ref(db, `USERS/${uid}`))
          .then((snap) => ({ uid, data: snap.exists() ? snap.val() : null }))
          .catch(() => ({ uid, data: null }))
      )
    ).then((results) => {
      const updates = {};
      results.forEach(({ uid, data }) => {
        updates[uid] = data; // can be null; indicates fetched but not found
      });
      setOwners((prev) => ({ ...prev, ...updates }));
    });
  }, [items, owners]);


const [selectedType, setSelectedType] = useState("all");
const [hidePrevious, setHidePrevious] = useState(true);
const [sortDirection, setSortDirection] = useState("asc");
const [selectedDate, setSelectedDate] = useState("");
const [priceRange, setPriceRange] = useState({ min: 0, max: 500 });
const [itemsPerPage, setItemsPerPage] = useState(50);
const [currentPage, setCurrentPage] = useState(1);
const [sortVerified, setVerifiedDirection] = useState("");
const [sortTitlelocationFilter, setsetsortTitlelocationFilter] = useState("");
const [sortByRecommended, setSortByRecommended] = useState("");
 
const [joinedEvents, setJoinedEvents] = useState({});

const [showFilter, setShowFilter] = useState(false);

  const activeFilterCount = React.useMemo(() => {
    let count = 0;

    if (sortTitlelocationFilter !== FILTERDEFAULTS.search) {
      count += 1;
    }

    if (selectedType !== FILTERDEFAULTS.type) {
      count += 1;
    }

    if (hidePrevious !== FILTERDEFAULTS.hidePrevious) {
      count += 1;
    }

    if (sortDirection !== FILTERDEFAULTS.sortDirection) {
      count += 1;
    }

    if (selectedDate !== "") {
      count += 1;
    }

    if (priceRange.min !== 0 || priceRange.max !== 500) {
      count += 1;
    }

    if (sortByRecommended !== "") {
      count += 1;
    }

    return count;
  }, [
    sortTitlelocationFilter,
    selectedType,
    hidePrevious,
    sortDirection,
    selectedDate,
    priceRange,
    sortByRecommended
  ]);

  // Fetch joined events on component mount or when currentUserId changes
  useEffect(() => {
    if (!currentUserId) return;

    const database = getDatabase();
    const userRef = ref(database, `USERS/${currentUserId}/ATTENDING/MUSIC`);

    const unsubscribe = onValue(userRef, (snapshot) => {
      const data = snapshot.val() || {};
      // Map joined events by their IDs
      const joined = {};
      Object.values(data).forEach(item => {
        if (item.eventId) joined[item.eventId] = true;
      });
      setJoinedEvents(joined);
    });

    return () => unsubscribe();
  }, [currentUserId]);

  // Join event function
const toggleJoinRace = async (eventData) => {
  if (!currentUserId) return;

  const database = getDatabase();

  // User join/leave location
  const raceRef = ref(
    database,
    `USERS/${currentUserId}/ATTENDING/MUSIC/${eventData.eventId}`
  );

  // Event attendee counter location
  const countRef = ref(
    database,
    `EVENTS/EVENT/MUSIC/${eventData.eventId}/ATTENDING_COUNT`
  );

  try {
    // Read ONCE (important: avoids repeated triggers)
    const snapshot = await get(raceRef);
    const alreadyJoined = snapshot.exists();

    if (alreadyJoined) {
      // --- USER LEAVES ---
      await remove(raceRef);
      setJoinedEvents((prev) => ({
        ...prev,
        [eventData.eventId]: false,
      }));

      // Decrease attendee count safely
      await runTransaction(countRef, (current) => {
        return Math.max((current || 0) - 1, 0); // prevents negative
      });

    } else {
      // --- USER JOINS ---
      await set(raceRef, eventData);
      setJoinedEvents((prev) => ({
        ...prev,
        [eventData.eventId]: true,
      }));

      // Increase attendee count safely
      await runTransaction(countRef, (current) => {
        return (current || 0) + 1;
      });
    }
  } catch (error) {
    console.error("Error toggling event:", error);
  }
};

  // Manual view transition handler for image expand animation
  const handleEventNavigation = (eventUrlKey, eventSlug) => {
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        return new Promise((resolve) => {
          startTransition(() => {
            navigate(`/event/${eventUrlKey}/${eventSlug}`);
            // Give the image time to load and render before completing transition
            setTimeout(() => {
              resolve();
            }, 50); // 50ms delay allows image to render
          });
        });
      });
    } else {
      // Fallback for browsers that don't support View Transitions API
      startTransition(() => {
        navigate(`/event/${eventUrlKey}/${eventSlug}`);
      });
    }
  };

  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");

    const timeout = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100); // small delay lets React render the list

    return () => clearTimeout(timeout);
  }, [location.hash]);

  // Reset pagination when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [sortTitlelocationFilter, selectedType, hidePrevious, sortDirection, selectedDate, priceRange, sortVerified, sortByRecommended]);



  return (

<div> 

<div className="event-page-title-section">
    <h1 className="text-start event-heading-start">Music Events.</h1>
    <p className="event-sub-text">
      Looking for the latest in music events? This page has you covered with everything from concerts and festivals to local gigs and more. Whether you’re a fan, musician, or just love the thrill of live performances, there’s something here for every music enthusiast to enjoy.</p>
</div>

  <div className="row justify-content-between filter-section mx-0 align-items-end">
  <div className="col-auto">
    <button className="btn btn-tertiary-outline" onClick={() => setShowFilter(prev => !prev)}>
      <i className='bi bi-filter me-1'></i> {showFilter ? "Filters" : "Filters"} 
      
        {activeFilterCount > 0 && (
         <i className={`ms-2 bi bi-${activeFilterCount}-circle-fill editedfilter-fade`}></i>
        )}
        
    </button>
  </div>

    <div className="col-auto"> 
          <div className="col-12 ">
            <label className="form-label mb-1"> 
              {sortTitlelocationFilter !== "" && (
                <span className="text-muted small">edited</span>
              )}
            </label>
              <input type="text"  className="form-control form-search" 
              id="sortTitlelocationFilter"
              placeholder="Search..."
              onChange={(e) => setsetsortTitlelocationFilter(e.target.value)}
              value={sortTitlelocationFilter}></input>
          </div>
    </div>
    
</div>


<div className="row">

{showFilter && (
  <div className="col-md-2 col-sm-12 mb-5">
  <div className=" desktop-sticky">
    <div className="row mb-3">


        <div className="col-12 mb-2 mb-md-2">
          <label className="form-label mb-1"> Type 
            {selectedType !== FILTERDEFAULTS.type && (
              <span className="ms-2 text-muted small">edited</span>
            )}
          </label>
                  
          <select className="form-select form-inherit" value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
            <option value="all">Show All</option>
            <option value="FESTIVAL">Festival</option>
            <option value="ROCK">Rock</option>
            <option value="INDIE">Indie</option>
            <option value="JAZZ">Jazz</option>
            <option value="DJ">DJ</option>
            <option value="DRUMANDBASS">Drum and Bass</option>
            <option value="COUNTRYFOLK">Country/Folk</option>
            <option value="METAL">Metal</option>
            <option value="POP">Pop</option>
            <option value="OTHER">Other</option>
          </select>

        </div>

        <div className="col-12 mb-2 mb-md-2">
          <label className="form-label mb-1"> Previous 
            {hidePrevious !== FILTERDEFAULTS.hidePrevious && (
              <span className="ms-2 text-muted small">edited</span>
            )}
          </label>
            <select
              className="form-select form-inherit"
              id="hidePreviousFilter"
              onChange={(e) => setHidePrevious(e.target.value === "hide")}
              value={hidePrevious ? "hide" : "show"}
            >
              <option value="hide">Upcoming Only</option>
              <option value="show">Show Previous</option>
             
            </select>
        </div>

        <div className="col-12 mb-2 mb-md-2">
          <label className="form-label mb-1"> Order By 
            {sortDirection !== FILTERDEFAULTS.sortDirection && (
              <span className="ms-2 text-muted small">edited</span>
            )}
          </label>

          <select
            className="form-select form-inherit"
            id="sortDirectionFilter"
            onChange={(e) => setSortDirection(e.target.value)}
            value={sortDirection}
          >
            <option value="asc">Closest</option>
            <option value="desc">Furthest</option>
          </select>

        </div>

        <div className="col-12 mb-2 mb-md-2">
          <label className="form-label mb-1"> From Date
            {selectedDate !== "" && (
              <span className="ms-2 text-muted small">edited</span>
            )}
          </label>
          <input
            type="date"
            className="form-control form-inherit"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        <div className="col-12 mb-2 mb-md-2">
          <label className="form-label mb-1"> Events Per</label>
          <select
            className="form-select form-inherit"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value="10">10 Events</option>
            <option value="25">25 Events</option>
            <option value="50">50 Events</option>
            <option value="85">85 Events</option>
            <option value="100">100 Events</option>
          </select>
        </div>

        <div className="col-12 mb-2 mb-md-0">
          <label className="form-label mb-1"> Price Range
            {(priceRange.min !== 0 || priceRange.max !== 500) && (
              <span className="ms-2 text-muted small">
                edited
              </span>
            )}
          </label>

          <div className="price-range-container">
            <div className="mb-0">
              <label className="form-label small mb-1">Min: £{priceRange.min}</label>
              <input
                type="range"
                className="form-range"
                min="0"
                max="250"
                step="5"
                value={priceRange.min}
                onChange={(e) => setPriceRange(prev => ({ ...prev, min: Math.min(Number(e.target.value), prev.max) }))}
              />
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1">Max: £{priceRange.max}</label>
              <input
                type="range"
                className="form-range"
                min="250"
                max="550"
                step="5"
                value={priceRange.max}
                onChange={(e) => setPriceRange(prev => ({ ...prev, max: Math.max(Number(e.target.value), prev.min) }))}
              />
            </div>
          </div>

        </div>

        <div className="col-12 mb-2 mb-md-0">
          <label className="form-label mb-1"> Verfied Only
            {sortVerified !== "" && (
              <span className="ms-2 text-muted small">
                edited
              </span>
            )}
          </label>

          <select
            className="form-select form-inherit"
            id="sortVerifiedFilter"
            onChange={(e) => setVerifiedDirection(e.target.value)}
            value={sortVerified}
          >
            <option value="">Any</option>
            <option value="Y">Verified Only</option>

          </select>

        </div>

        <div className="col-12 mb-2 mb-md-0">
          <label className="form-label mb-1">Recommendations
            {sortByRecommended !== "" && (
              <span className="ms-2 text-muted small">
                edited
              </span>
            )}
          </label>

          <select
            className="form-select form-inherit"
            id="sortByRecommendedFilter"
            onChange={(e) => setSortByRecommended(e.target.value)}
            value={sortByRecommended}
          >
            <option value="">Default</option>
            <option value="highest">Highest Recommended</option>
            <option value="lowest">Lowest Recommended</option>
            <option value="recommended-only">Recommended Only</option>
          </select>

        </div>


    </div>
  </div>
  </div>
)}

<div id="contentColumn" className={`col-sm-12 ${showFilter ? "col-md-10" : "col-md-12"}`}>
  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
    {loading ? (
      [...Array(3)].map((_, index) => (
        <React.Fragment key={index}>
            <div className="col hover:opacity-95 mb-3">
            <div className="placeholder-glow">
              
                <div className="card-text mb-0">
                  <div className="position-relative text-center">
                    <div className="bg-gray-300 rounded-lg w-full sm:aspect-2/1 max-sm:h-80 placeholder"></div>
                  </div>
                </div>

              <div className="card-body p-1">

                <div className="row align-items-center justify-items-start my-2">
                  <div className="col-12">
                    <div className="btn pill-button placeholder col-12"> loading </div>
                  </div>
                </div>

                <div className="row align-items-center justify-items-between">
                  <div className="col-12">
                    <p className="card-text mb-0 fw-medium text-dark mb-2 placeholder col-6 rounded-lg" ></p>
                  </div>
                </div>

                <div className="row align-items-center justify-items-between">
                  <div className="col-6">
                    <p className="card-text mb-0 fw-medium text-gray-500 mb-2 placeholder col-12 rounded-lg">&nbsp;</p>
                  </div>
                  
                  <div className="col-6">
                    <p className="card-text mb-0 fw-medium text-gray-500 mb-2 placeholder col-6 rounded-lg">&nbsp;</p>
                  </div>
                </div>
                
                <div className="row align-items-center justify-items-between">
                  <div className="col-2">
                    <p className="card-text mb-0 fw-medium  text-dark mb-2 placeholder col-12 rounded-lg">&nbsp;</p>
                  </div>
                  
                  <div className="col-6">
                    <p className="card-text mb-0 fw-medium text-dark mb-2 placeholder col-6 rounded-lg">&nbsp;</p>
                  </div>
                </div>

              </div>

              <div className="row justify-content-between" role="group" aria-label="Basic example">
                <div className="col-6">
                  <div className="btn text-center btn-tertiary placeholder col-6">loading</div>
                </div>
                <div className="col-6 text-end">
                  <div className="btn text-center btn-secondary placeholder col-6">loading</div>
                </div>
              </div>
              
            </div>
          </div>
        </React.Fragment>
      ))
    ) : items && items.length > 0 ? (
      (() => {
        const filteredItems = items
          .filter(item => item.EVENT_PUBLIC === "Y")
          .filter(item => sortTitlelocationFilter === "" || item.EVENT_NAME.toLowerCase().includes(sortTitlelocationFilter.toLowerCase())  || item.EVENT_LOCATION.toLowerCase().includes(sortTitlelocationFilter.toLowerCase()))
          .filter(item => {
            if (selectedDate === "") return true;
            const [day, month, year] = item.EVENT_DATE.split("/");
            const eventDate = new Date(`${year}-${month}-${day}`);
            const filterDate = new Date(selectedDate);
            return eventDate >= filterDate;
          })
          .filter(item => Number(item.EVENT_PRICE) >= priceRange.min && Number(item.EVENT_PRICE) <= priceRange.max)
          .filter(item => sortVerified === "" || item.EVENT_VERIFIED === sortVerified)
          .filter(item => selectedType === "all" || item.EVENT_TYPE === selectedType)
          .filter(item => !hidePrevious || !item.isExpiredtext?.includes("grayscale") || item.isOneDayExpired)
          .filter(item => sortByRecommended !== "recommended-only" || (item.REACTIONS && Object.keys(item.REACTIONS).length > 0))
          .sort((a, b) => {
            // Sort by recommendations if selected
            if (sortByRecommended === "highest") {
              const aRecommendCount = a.REACTIONS ? Object.keys(a.REACTIONS).length : 0;
              const bRecommendCount = b.REACTIONS ? Object.keys(b.REACTIONS).length : 0;
              return bRecommendCount - aRecommendCount; // Highest first
            } else if (sortByRecommended === "lowest") {
              const aRecommendCount = a.REACTIONS ? Object.keys(a.REACTIONS).length : 0;
              const bRecommendCount = b.REACTIONS ? Object.keys(b.REACTIONS).length : 0;
              return aRecommendCount - bRecommendCount; // Lowest first
            }

            // Default sort by date
            const parseDate = (str) => {
              const [day, month, year] = str.split("/");
              return new Date(`${year}-${month}-${day}`);
            };

            const dateA = parseDate(a.EVENT_DATE);
            const dateB = parseDate(b.EVENT_DATE);

            return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
          });

        const startIndex = 0;
        const endIndex = currentPage * itemsPerPage;
        const paginatedItems = filteredItems.slice(startIndex, endIndex);

        return (
          <>
            {paginatedItems.length > 0 ? (
              paginatedItems.map(item => (
                <React.Fragment key={item.id}>
        {/* Card */}
        <div
          className="col-md-4 col-sm-12 mb-5" id={`event-card-${item.id}`}
        >
          <div className="card-content-body">
            <div 
              onClick={() => handleEventNavigation(item.EVENT_URLKEY, item.EVENT_SLUG)}
              role="group"
              style={{ cursor: "pointer" }}
            >
              <div className={`card-text mb-0 ${item.expiredEvent}`}>{item.label}</div>
            </div>

            <div className="card-body p-1">
              <div className="row align-items-center justify-items-between">
                
               <div className="col-12">

                        <Link to={`/event/${item.EVENT_URLKEY}/${item.EVENT_SLUG}`}  role="group">
                          <p className={`card-title mb-1 ${item.isExpiredtext} mt-2`}>
                            {item.EVENT_NAME || "Untitled Event"}
                          </p>
                        </Link>

                        <p className={`card-text mb-1 ${item.isExpiredtext}`}>
                          <span className=""> {item.dateDayDisplay} {" "} </span>
                                  <span className=""> {item.dateDateDisplay} </span>
                                  {Number(item.EVENT_EXTRADAYS) > 0 && (
                                    <span className="">
                                      {" - " + item.dateEndDateDisplay}
                                    </span>
                                  )}
                             <span className="">{item.dateMonthDisplay} </span>
                             <span className="">{item.dateYearDisplay} </span>
                        </p>

                        <p className={`card-text card-location mb-0 user-select-all ${item.isExpiredtext}`}>
                        {item.EVENT_LOCATION || "TBC."}, {item.EVENT_POSTCODE || "TBC."}
                        </p>
                        
                </div>

              </div>
            </div>

              <div className="row justify-content-between align-items-center">

                <div className="col-auto">
                    <button className={`event-badges`}> <i className={`bi bi-circle-half me-1 ${item.EVENT_TYPE}-badge`}></i> {item.EVENT_TYPE} </button>
                    {item.REACTIONS && Object.keys(item.REACTIONS).length > 0 && (
                      <button className={`event-badges ms-2`} disabled> 
                        <i className={`bi bi-hand-thumbs-up me-1 recommend-badge2`}></i> {Object.keys(item.REACTIONS).length} <span className="hide-rec-screen"> Recommend </span> 
                      </button>
                    )}
                </div>

                  <div className="col-auto">
                    {currentUserId && (
                      <button
                        className={`text-center ${joinedEvents[item.id] ? 'btn-leave-round' : 'btn-join-round'}`}
                        onClick={() =>
                          toggleJoinRace({
                            eventId: item.id,
                            joinedAt: Date.now(),
                          })
                        }
                      >
                
                        {joinedEvents[item.id] ? (
                          <>
                            <i className="bi bi-arrow-left me-1 small"></i> Leave 
                          </>
                        ) : (
                          <>
                            Attend <i className="bi bi-arrow-right ms-1 small"></i>
                          </>
                        )}
                      </button>
                    )}
                  </div>

              </div>

          </div>
        </div>


      
      </React.Fragment>
              ))
            ) : (
              <div className="">
                <div className="">
                  <h1 className="text-start event-heading-start">No more events</h1> 
                  <p className="text-start event-sub-text">It seems there are no more events available at the moment, feel free to create one using the button below.</p>
                  <div><a href="/CreateEvent" className="btn btn-primary">Create a Event</a></div>
                </div>
              </div>
            )}
          </>
        );
      })()
    ) : (
      <>
      </>
    )}

  </div>
</div>

</div>

 </div>
  );
}

export default MusicContent;

